import * as React from 'react';

import styles from './MobileBottomWrapper.css';
import { useMobileBottomNavigation } from '../../hooks/useMobileBottomNavigationEnabled';

/**
 * Wrapper для того, чтобы изменить кнопке "Открыть приложение" position
 * Временный хак, выпилится после эксперимента vx_mobweb_bx_349_bottom_navigation_v2
 */
export const MobileBottomWrapper: React.FC<React.PropsWithChildren> = ({ children }) => {
  const isMobileNavigationEnabled = useMobileBottomNavigation();

  if (!isMobileNavigationEnabled) {
    return children;
  }

  return <div className={styles['wrapper']}>{children}</div>;
};
